import { fetcher } from "../../utils/fetcher";

export const getLinkedCounts = async (projectId) => {
  return await fetcher.get(`/api/tasks/linked-counts?projectId=${projectId}`);
};
